import type { Notification } from './types';

export const notifications: Notification[] = [
  {
    id: '1',
    title: '系统维护通知',
    type: 'platform',
    content: '尊敬的用户，为了给您提供更好的服务体验，我们将于2024年1月20日凌晨2:00-6:00进行系统维护升级。维护期间部分功能可能暂时无法使用，给您带来的不便敬请谅解。维护完成后，系统将自动恢复正常运行。',
    target: 'all-users',
    status: 'sent',
    notificationTime: '2024-01-20 02:00:00',
    createTime: '2024-01-15 14:30:00',
    creator: '张伟'
  },
  {
    id: '2',
    title: '春节活动优惠通知',
    type: 'activity',
    content: '新春佳节即将来临，为回馈广大用户的支持与厚爱，我们特别推出春节充值优惠活动！活动期间充值满500元即可获赠50元，充值满1000元即可获赠120元，充值满2000元即可获赠300元。活动时间：2024年2月1日-2月15日，数量有限，先到先得！',
    target: 'all-users',
    status: 'sent',
    notificationTime: '2024-02-01 10:00:00',
    createTime: '2024-01-25 16:20:00',
    creator: '李娜'
  },
  {
    id: '3',
    title: '学校管理员权限升级通知',
    type: 'platform',
    content: '尊敬的学校管理员，为了更好地满足学校管理需求，我们对管理员权限进行了全面升级。新增功能包括：批量导入学生信息、自定义报表导出、实时监控学生使用情况、灵活的权限分配机制等。请登录系统查看详细功能说明。',
    target: 'all-schools',
    status: 'sent',
    notificationTime: '2024-01-18 09:00:00',
    createTime: '2024-01-16 11:45:00',
    creator: '王强'
  },
  {
    id: '4',
    title: '企业版功能更新通知',
    type: 'platform',
    content: '尊敬的企业管理员，我们很高兴地通知您，企业版已完成重大功能更新！本次更新包括：新增团队协作功能、优化资源分配算法、增强数据安全防护、支持多级审批流程、新增财务对账功能等。欢迎体验新功能，如有任何问题请联系客服。',
    target: 'all-enterprises',
    status: 'sent',
    notificationTime: '2024-01-22 14:00:00',
    createTime: '2024-01-20 10:15:00',
    creator: '刘芳'
  },
  {
    id: '5',
    title: '寒假特惠活动预告',
    type: 'activity',
    content: '寒假即将到来，为了让同学们在假期也能愉快学习，我们推出寒假特惠套餐！购买30天云电脑套餐享8折优惠，购买60天套餐享7折优惠，购买90天套餐享6折优惠。活动时间：2024年1月25日-2月25日。名额有限，欲购从速！',
    target: 'all-users',
    status: 'pending',
    notificationTime: '2024-01-25 10:00:00',
    createTime: '2024-01-22 15:30:00',
    creator: '陈明'
  },
  {
    id: '6',
    title: '隐私政策更新通知',
    type: 'platform',
    content: '尊敬的用户，根据最新的数据保护法规要求，我们对隐私政策进行了更新。主要变更包括：明确数据收集范围、优化数据使用说明、增强用户权利保障、完善数据安全措施等。更新后的隐私政策将于2024年2月1日生效，请您仔细阅读。继续使用我们的服务即表示您同意新的隐私政策。',
    target: 'all-users',
    status: 'pending',
    notificationTime: '2024-02-01 00:00:00',
    createTime: '2024-01-23 09:20:00',
    creator: '张伟'
  },
  {
    id: '7',
    title: '学校账单结算提醒',
    type: 'platform',
    content: '尊敬的学校管理员，本月账单已生成，请及时查看并完成结算。本月总消费金额：￥125,680.00，其中云电脑费用：￥98,500.00，云存储费用：￥27,180.00。请于2024年2月5日前完成付款，逾期将影响服务使用。如有疑问，请联系财务部门。',
    target: 'all-schools',
    status: 'pending',
    notificationTime: '2024-02-01 09:00:00',
    createTime: '2024-01-28 16:00:00',
    creator: '李娜'
  },
  {
    id: '8',
    title: '新功能体验邀请',
    type: 'activity',
    content: '我们即将推出全新的AI智能助手功能！该功能可以帮助您快速解决使用过程中遇到的问题，提供个性化的使用建议，优化资源配置方案。现诚邀您参与内测体验，前100名报名用户将获得3个月的免费使用权限。报名时间：2024年2月1日-2月10日。',
    target: 'all-users',
    status: 'pending',
    notificationTime: '2024-02-01 10:00:00',
    createTime: '2024-01-26 14:25:00',
    creator: '王强'
  }
];
